import React from 'react';

import Layout from '@/components/v2/Layout';

import PlatformInstructions from './PlatformInstructions';

const PlatformUsage = () => {
  return (
    <Layout>
      <PlatformInstructions />
    </Layout>
  );
};

export default PlatformUsage;
